import React from 'react';
import { styled } from '@this/constants/themes';
import type User from '../../../domain/user/user';
import { AI_EXPENSE_COLORS } from '../constants/colors';

interface Props {
  user: User | null | undefined;
}

const ExpensesFooter = ({ user }: Props) => (
  <Footer>
    <FooterContainer>
      <Content>
        <NaviList>
          <NaviItem>
            <NaviLink href="https://transferdata.co.jp/about" target="_blank">
              会社概要
            </NaviLink>
          </NaviItem>
          <NaviItem>
            <NaviLink href="https://aiexpense.cloud/kiyaku" target="_blank">
              利用規約
            </NaviLink>
          </NaviItem>
          <NaviItem>
            <NaviLink
              href="https://storage.googleapis.com/studio-design-asset-files/projects/NxqgnzDVO1/s-1x1_e5aa654c-ec2f-41b6-bbd2-56e2edc060f7.pdf"
              target="_blank"
            >
              マニュアル
            </NaviLink>
          </NaviItem>
          <NaviItem>
            <NaviLink href="https://aitravel.cloud/sct" target="_blank">
              特定商取引に関する法律に基づく表記
            </NaviLink>
          </NaviItem>
          <NaviItem>
            <NaviLink href="https://transferdata.co.jp/privacy-policy#a" target="_blank">
              個人情報保護方針 / 個人情報の取り扱いについて
            </NaviLink>
          </NaviItem>
          {user ? (
            <NaviItem>
              <NaviLink href="/biztra/users/sign_out">ログアウト</NaviLink>
            </NaviItem>
          ) : null}
        </NaviList>
      </Content>
      <Logo>
        <p style={{ fontSize: '0.8em' }}>Transfer Data Inc.</p>
      </Logo>
    </FooterContainer>
  </Footer>
);

const footerBgColor = `#faf9f8`;

const Footer = styled.footer`
  background: ${footerBgColor};
  min-height: 50px;
  text-align: center;
`;

const FooterContainer = styled.div`
  max-width: 1000px;
  min-height: 50px;
  margin: auto;
`;

const Content = styled.div`
  float: left;
  width: calc(100% - 120px - 15px);
  @media screen and (max-width: 767px) {
    width: 100%;
  }
`;

const NaviList = styled.ul`
  padding: 15px;
  text-align: left;
  @media screen and (max-width: 767px) {
    padding: 0 15px;
  }
`;

const NaviItem = styled.li`
  display: inline-block;
  margin-left: 20px;
  &:first-child {
    margin-left: 0;
  }
  @media screen and (max-width: 767px) {
    margin-bottom: 10px;
    &:first-child {
      margin-left: 20px;
    }
  }
`;

const NaviLink = styled.a`
  font-size: 0.8em;
  color: ${AI_EXPENSE_COLORS.brand.primary};
  &:hover {
    color: ${AI_EXPENSE_COLORS.brand.hover};
  }
  &:focus {
    color: ${AI_EXPENSE_COLORS.brand.primary};
    outline: 2px solid ${AI_EXPENSE_COLORS.brand.primary};
    outline-offset: 2px;
  }
  &:active {
    color: ${AI_EXPENSE_COLORS.brand.hover};
  }
`;

const Logo = styled.div`
  float: left;
  box-sizing: content-box;
  width: 120px;
  padding: 18px 10px 15px 0;
  @media screen and (max-width: 767px) {
    width: 100%;
    padding: 0;
    margin-bottom: 25px;
  }
`;

export default ExpensesFooter;
